import { render } from "./Advanced.vue?vue&type=template&id=1cdfc060"
import script from "./Advanced.vue?vue&type=script&lang=js"
export * from "./Advanced.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.14.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__